import {
  Button,
  CardHeader,
  CardTitle,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@ais-ui/ui-core';
import { PiSlidersHorizontal } from 'react-icons/pi';
import { XIcon } from 'lucide-react';
import React, { useState } from 'react';

interface CustomizePopoverProps {
  children: React.ReactNode;
}

export const CustomizePopover = ({ children }: CustomizePopoverProps) => {
  const [open, setOpen] = useState(false);

  return (
    <Tooltip>
      <Popover open={open} onOpenChange={setOpen}>
        <TooltipTrigger asChild>
          <PopoverTrigger asChild>
            <Button variant="outline" size="icon">
              <PiSlidersHorizontal className="h-6 w-6"></PiSlidersHorizontal>
            </Button>
          </PopoverTrigger>
        </TooltipTrigger>
        <PopoverContent className="w-full" align="end" side="left">
          <CardHeader className="p-2 space-y-1">
            <div className="flex justify-between">
              <CardTitle className="text-lg font-medium">Customize</CardTitle>
              <Button
                variant="ghost"
                size="icon"
                className="-mt-5 -mr-5"
                onClick={() => setOpen(false)}
              >
                <XIcon className="size-4" />
              </Button>
            </div>
            <div className="text-sm text-muted-foreground">
              Customize the appearance of your report.
            </div>
          </CardHeader>
          {children}
        </PopoverContent>
      </Popover>
      <TooltipContent>Customize report</TooltipContent>
    </Tooltip>
  );
};
